(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(function() {
  var section = document.querySelector('.product-recommendations');
  if (!section) return;

  var url = section.dataset.url;
  if (!url) return;

  var observer = new IntersectionObserver(function(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(section);

    fetch(url)
      .then(function(response) { return response.text(); })
      .then(function(htmlText) {
        var container = document.createElement('div');
        container.innerHTML = htmlText;
        var recommendations = container.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length > 0) {
          section.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(function(error) {
        console.error('Product recommendations load error', error);
      });
  }, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(section);
})();

  } catch(e) { console.error(e); }
})();
})();
